import { useEffect, useRef } from 'react'
import type { KnowledgeDocumentIndexingUpdatedEvent } from '@digital-twins/shared-types'
import { onKnowledgeDocumentIndexingUpdated } from '@/lib/services/websocket'

export interface UseKnowledgeDocumentIndexingUpdatesOptions {
  /**
   * When false, skip the websocket subscription. Defaults to true so existing
   * call sites (upload page, document detail) are unchanged. Knowledge Hub
   * passes false when Assistant is locked (assistant-beta-launch-plan Step 5).
   */
  enabled?: boolean
}

/**
 * Subscribe to org-room indexing status updates for Knowledge Hub / upload UI.
 * Clients already join `organization:{token}` on socket connect.
 * Handler is kept in a ref so callers can pass an inline function safely.
 */
export function useKnowledgeDocumentIndexingUpdates(
  onUpdate: (event: KnowledgeDocumentIndexingUpdatedEvent) => void,
  options: UseKnowledgeDocumentIndexingUpdatesOptions = {},
): void {
  const enabled = options.enabled !== false
  const onUpdateRef = useRef(onUpdate)
  onUpdateRef.current = onUpdate

  useEffect(() => {
    if (!enabled) {
      return
    }
    return onKnowledgeDocumentIndexingUpdated((event) => {
      onUpdateRef.current(event)
    })
  }, [enabled])
}
